import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "me-1 ms-auto" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge badge-pill badge-gray" }, " New ")
], -1 /* HOISTED */)
const _hoisted_3 = { class: "mt-2" }
const _hoisted_4 = { class: "table table-responsive-md border border-gray overflow-auto" }
const _hoisted_5 = { class: "bg-table-header" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", null, "Problem", -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", null, "Onset Date", -1 /* HOISTED */)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Last Addressed ")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-info" }, null, -1 /* HOISTED */)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Present on Admission", -1 /* HOISTED */)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, "Actions", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableEmpty = _resolveComponent("TableEmpty")!
  const _component_ProblemsTableRow = _resolveComponent("ProblemsTableRow")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("button", {
        class: "btn btn-primary btn-xs ms-2",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addProblem()))
      }, "Add Problem")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("table", _hoisted_4, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _createElementVNode("th", null, [
              _hoisted_8,
              _withDirectives((_openBlock(), _createElementBlock("span", null, _hoisted_10)), [
                [_directive_tooltip, {
                                title: 'This is the last date that this problem was addressed in a visit note.'
                            }]
              ])
            ]),
            _hoisted_11,
            _hoisted_12
          ])
        ]),
        _createCommentVNode("Empty Table"),
        (_ctx.problems.length == 0 && _ctx.newProblems.length == 0)
          ? (_openBlock(), _createBlock(_component_TableEmpty, {
              key: 0,
              "col-span": _ctx.columns,
              component: "problems",
              "secondary-message": "No Problems Found"
            }, null, 8 /* PROPS */, ["col-span"]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode("Existing Diagnoses"),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeProblems, (problem, index) => {
          return (_openBlock(), _createBlock(_component_ProblemsTableRow, {
            index: index,
            key: problem.id,
            problem: problem,
            "move-problem-up": _ctx.moveProblem,
            "move-problem-down": _ctx.moveProblem,
            "resolve-problem": _ctx.resolveProblem,
            first: index === 0,
            last: index === _ctx.activeProblems.length - 1,
            id: _ctx.id,
            deleteProblem: _ctx.deleteProblem,
            application: _ctx.application
          }, null, 8 /* PROPS */, ["index", "problem", "move-problem-up", "move-problem-down", "resolve-problem", "first", "last", "id", "deleteProblem", "application"]))
        }), 128 /* KEYED_FRAGMENT */)),
        _createCommentVNode("New Diagnoses"),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newProblems, (problem, index) => {
          return _withDirectives((_openBlock(), _createBlock(_component_ProblemsTableRow, {
            index: index,
            key: problem.id,
            problem: problem,
            updateProblem: _ctx.updateProblem,
            "is-add-requested": _ctx.isAddRequested,
            "onUpdate:is-add-requested": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isAddRequested) = $event)),
            "save-new-problem": _ctx.saveNewProblem,
            "cancel-save-new-problem": _ctx.cancelSaveNewProblem,
            "is-new-terminal": _ctx.isNewTerminal,
            application: _ctx.application
          }, null, 8 /* PROPS */, ["index", "problem", "updateProblem", "is-add-requested", "save-new-problem", "cancel-save-new-problem", "is-new-terminal", "application"])), [
            [_vShow, _ctx.newProblems.length > 0]
          ])
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}